class Helpers {
    static async checkImageExists(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
      });
    }

    static eliminarNull(objeto) {
        let obj = {...objeto}
        for (let clave in obj) {
          if (obj[clave] === null) {
            delete obj[clave];
          }
        }

        return  obj
      }

}



export default Helpers;
